// extracted by mini-css-extract-plugin
module.exports = {"dp3-crowdfunding-tc":"TAndC_dp3-crowdfunding-tc__rPVoF"};